import * as Popover from '@radix-ui/react-popover';
import { useRef, useState, type ReactNode } from 'react';

export function InfoTip({
  label,
  name = 'manufactured-size-info',
  children,
}: {
  label: string;
  name?: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const openedOnHover = useRef(false);

  return (
    <Popover.Root
      open={open}
      onOpenChange={(value) => {
        openedOnHover.current = false;
        setOpen(value);
      }}
    >
      <Popover.Trigger
        type="button"
        data-name={name}
        aria-label={label}
        onPointerEnter={(event) => {
          if (event.pointerType === 'mouse' && !open) {
            openedOnHover.current = true;
            setOpen(true);
          }
        }}
        onPointerLeave={(event) => {
          if (event.pointerType === 'mouse' && openedOnHover.current) {
            openedOnHover.current = false;
            setOpen(false);
          }
        }}
        onClick={(event) => {
          // A click pins an already-hovered popover open.
          if (openedOnHover.current) {
            event.preventDefault();
            openedOnHover.current = false;
          }
        }}
        className="-m-2 inline-flex size-10 shrink-0 touch-manipulation items-center justify-center text-progress focus-visible:rounded-sm focus-visible:outline-2 focus-visible:outline-brand"
      >
        <svg
          aria-hidden="true"
          className="size-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 11v6" />
          <circle cx="12" cy="7.5" r=".5" fill="currentColor" stroke="none" />
        </svg>
      </Popover.Trigger>
      <Popover.Content
        side="top"
        sideOffset={4}
        collisionPadding={16}
        aria-label={label}
        onOpenAutoFocus={(event) => event.preventDefault()}
        className="z-50 w-[min(20rem,calc(100vw-2rem))] rounded-lg border border-gray-200 bg-white p-3 text-xs leading-relaxed text-gray-700 shadow-md outline-none"
      >
        {children}
      </Popover.Content>
    </Popover.Root>
  );
}
